export default __webpack_public_path__ + "static/media/personIcon.a296afc6.svg";